import { ExternalLink } from "@octopusdeploy/design-system-components";
import { LearnMoreResources, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
export const ProjectRunbooksTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="RunbookExamples">Runbook examples</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
